import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbsDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="thumbs-down, thumb, hand, no, contra"><path fillRule="evenodd" clipRule="evenodd" d="M18.0022 4.5V12.5H20.5002V4.5H18.0022ZM17.5809 14H21.2502C21.6644 14 22.0002 13.6642 22.0002 13.25V3.75C22.0002 3.33579 21.6644 3 21.2502 3H6.58575C4.733 3 3.15858 4.35403 2.87996 6.1859L2.04344 11.6859C1.69829 13.9552 3.45391 16 5.74923 16H10.1134L9.67296 18.8264C9.41317 20.4935 10.7016 22 12.3891 22H13.0044C13.2853 22 13.5426 21.8431 13.6712 21.5933L17.5809 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconThumbsDown;
